import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import { Col, Form, Row } from 'react-bootstrap';


export default function SetDescribealbeScoreCommentsFull({onAccept, onClose, studentName, index
      , positiveCommentVeryGood, negativeCommentVeryGood, recommendationVeryGood
      , positiveCommentGood, negativeCommentGood, recommendationGood
      , positiveCommentAcceptable, negativeCommentAcceptable, recommendationAcceptable
      , positiveCommentRejected, negativeCommentRejected, recommendationRejected
    }) {
  const [selectedItems, setSelectedItems] = useState(null);


  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [positiveVeryGood, setPositiveVeryGood] = useState(positiveCommentVeryGood);
  const [negativeVeryGood, setNegativeVeryGood] = useState(negativeCommentVeryGood);
  const [recommendVeryGood, setRecommendVeryGood] = useState(recommendationVeryGood);
  const [positiveGood, setPositiveGood] = useState(positiveCommentGood);
  const [negativeGood, setNegativeGood] = useState(negativeCommentGood);
  const [recommendGood, setRecommendGood] = useState(recommendationGood);
  const [positiveAcceptable, setPositiveAcceptable] = useState(positiveCommentAcceptable);
  const [negativeAcceptable, setNegativeAcceptable] = useState(negativeCommentAcceptable);
  const [recommendAcceptable, setRecommendAcceptable] = useState(recommendationAcceptable);
  const [positiveRejected, setPositiveRejected] = useState(positiveCommentRejected);
  const [negativeRejected, setNegativeRejected] = useState(negativeCommentRejected);
  const [recommendRejected, setRecommendRejected] = useState(recommendationRejected);

  useEffect(() => {
  }, []);

  const saveItem = function () {
    onAccept(index
      , positiveVeryGood, negativeVeryGood, recommendVeryGood
      , positiveGood, negativeGood, recommendGood
      , positiveAcceptable, negativeAcceptable, recommendAcceptable
      , positiveRejected, negativeRejected, recommendRejected);
  }
  const formDialogFooter = function () {
    return (
      <GeneralDialogFooter onOkClick={() => { saveItem() }} onCancelClick={() => { onClose() }} saving={false} />
    )
  }

  return (
    <>
      <Dialog visible={true} style={{ width: '90%' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header="ثبت نظر توصیفی" modal className="p-fluid" footer={() => formDialogFooter()} onHide={() => onClose()}>
          <Row style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
            <Col md={12}>
              {studentName}
            </Col>
          </Row>
          <Row style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
            <Col md={3}>
              نقاط قوت(خیلی خوب):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setPositiveVeryGood(e.target.value)}} value={positiveVeryGood} />
            </Col>
            <Col md={3}>
              نقاط قوت(خوب):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setPositiveGood(e.target.value)}} value={positiveGood} />
            </Col>
            <Col md={3}>
              نقاط قوت(قابل قبول):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setPositiveAcceptable(e.target.value)}} value={positiveAcceptable} />
            </Col>
            <Col md={3}>
              نقاط قوت:(نیاز به تلاش):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setPositiveRejected(e.target.value)}} value={positiveRejected} />
            </Col>
          </Row>
          <Row style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
            <Col md={3}>
              نقاط ضعف(خیلی خوب):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setNegativeVeryGood(e.target.value)}} value={negativeVeryGood} />
            </Col>
            <Col md={3}>
              نقاط ضعف(خوب):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setNegativeGood(e.target.value)}} value={negativeGood} />
            </Col>
            <Col md={3}>
              نقاط ضعف(قابل قبول):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setNegativeAcceptable(e.target.value)}} value={negativeAcceptable} />
            </Col>
            <Col md={3}>
              نقاط ضعف:(نیاز به تلاش):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setNegativeRejected(e.target.value)}} value={negativeRejected} />
            </Col>
          </Row>
          <Row style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
            <Col md={3}>
              پیشنهاد(خیلی خوب):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setRecommendVeryGood(e.target.value)}} value={recommendVeryGood} />
            </Col>
            <Col md={3}>
              پیشنهاد(خوب):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setRecommendGood(e.target.value)}} value={recommendGood} />
            </Col>
            <Col md={3}>
              پیشنهاد(قابل قبول):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setRecommendAcceptable(e.target.value)}} value={recommendAcceptable} />
            </Col>
            <Col md={3}>
              پیشنهاد(نیاز به تلاش):
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setRecommendRejected(e.target.value)}} value={recommendRejected} />
            </Col>
          </Row>
      </Dialog>




      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
    </>
  );
}
